var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUpload2 = function SvgUpload2(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6853_39411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16L12 12L8 16",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12V21",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39 18.3895C21.3654 17.8578 22.1359 17.0164 22.5799 15.9981C23.0239 14.9799 23.1162 13.8427 22.8422 12.7662C22.5682 11.6896 21.9435 10.735 21.0667 10.0529C20.1899 9.37088 19.1109 9.00023 18 8.9995H16.74C16.4373 7.82874 15.8732 6.74183 15.09 5.82049C14.3068 4.89915 13.3249 4.16735 12.2181 3.6801C11.1114 3.19286 9.90857 2.96285 8.70014 3.00738C7.4917 3.0519 6.30909 3.3698 5.2412 3.93716C4.17331 4.50453 3.24793 5.3066 2.53464 6.28308C1.82135 7.25956 1.33871 8.38503 1.123 9.57489C0.907291 10.7647 0.964126 11.988 1.28923 13.1528C1.61434 14.3175 2.19926 15.3934 3.00002 16.2995",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L12 12L8 16",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6853_39411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-2.0c4f02e0.svg";
export { ForwardRef as ReactComponent };